import { taggedTemplateLiteral as _taggedTemplateLiteral } from '../../_virtual/_rollupPluginBabelHelpers.js';
import styled from 'styled-components';
import Theme from '../../Theme/index.js';

var _templateObject;
var _Theme$colors = Theme.colors,
  white = _Theme$colors.white,
  bgGrey = _Theme$colors.bgGrey;
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background: ", ";\n  padding: 50px 0 25px;\n  border-top: 2px solid ", ";\n"])), white, bgGrey);

export { Wrapper as default };
